import React, { useCallback, useMemo, useRef, useState } from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import { fromEventToValue } from 'utils/converters/event.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import isTouchDevice from 'utils/dom/isTouchDevice.util';
import logger from 'utils/logger.util';

import searchByName from 'lib/searchByName';

import CN from './SearchSelectBar.module.scss';

const L = logger('SearchSelectBar');

const SearchSelectBar = ({ options, onSelect, onStartSearching, placeholder, className, children }) => {
  const searchInputRef = useRef(null);
  const { isDarkMode } = useTheme();
  const isTouch = isTouchDevice();

  const [query, setQuery] = useState('');
  const filteredOptions = useMemo(() => searchByName(query, options), [query, options]);

  const handleChange = useCallback(
    (ev) => {
      const value = fromEventToValue(ev);

      setQuery(value);
      onStartSearching(fromAnyToBool(value));
    },
    [onStartSearching],
  );
  const handleSelect = useCallback(
    (item) => {
      if (!item) {
        L.warn('handleSelect()', 'item:', item);
        return;
      }
      onSelect(item);
      setQuery('');
      onStartSearching(false);
    },
    [onStartSearching, onSelect],
  );

  const showOptions = fromAnyToBool(query.length > 0 && options.length > 0);

  return (
    <div
      data-bem="SearchSelectBar"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
        [className]: true,
      })}
    >
      {/* no focus if is mobile device */}
      <input
        type="text"
        className={CN.input}
        placeholder={placeholder}
        id="InputSearchSelectBar"
        value={query}
        onChange={handleChange}
        autoComplete="off"
        ref={!isTouch ? searchInputRef : undefined} // undefined because false is not a valid value for ref
      />
      {showOptions && <div className={CN.optionsContainer}>{filteredOptions.map((option) => children(option, handleSelect))}</div>}
    </div>
  );
};

export default SearchSelectBar;
